module.exports = __webpack_public_path__ + "full-screen-icon-8564b5234492758e3c89.png";